/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeLocation } from '../../models/employee-location';

export interface GetAllEmployeeLocations$Json$Params {
}

export function getAllEmployeeLocations$Json(http: HttpClient, rootUrl: string, params?: GetAllEmployeeLocations$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EmployeeLocation>>> {
  const rb = new RequestBuilder(rootUrl, getAllEmployeeLocations$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EmployeeLocation>>;
    })
  );
}

getAllEmployeeLocations$Json.PATH = '/api/EmployeeLocation';
